export default 100;



// WEBPACK FOOTER //
// ./src/common/mock/delay.js